import {
    Directive,
    ElementRef,
    HostListener,
    Renderer2,
    Output,
    EventEmitter,
  } from '@angular/core';
  
  @Directive({
    selector: '[appDniFormatter]',
  })
  export class DniFormatterDirective {
    @Output() valueChange = new EventEmitter<string>();
  
    constructor(private el: ElementRef, private renderer: Renderer2) {}
  
    @HostListener('input', ['$event.target.value']) onInput(value: string) {
      const formatted = this.formatDni(value);
      this.renderer.setProperty(this.el.nativeElement, 'value', formatted);
      this.valueChange.emit(formatted);
    }
  
    @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
      event.preventDefault();
      const pasted = event?.clipboardData?.getData('text/plain') || '';
      const formatted = this.formatDni(pasted);
      this.renderer.setProperty(this.el.nativeElement, 'value', formatted);
      this.valueChange.emit(formatted);
    }
  
    private formatDni(value: string): string {
      const digits = value.replace(/\D/g, '').slice(0, 8);
  
      if (digits.length <= 2) return digits;
      if (digits.length <= 5) return digits.replace(/^(\d{2,3})(\d{1,3})/, '$1.$2');
      return digits.replace(/^(\d{2})(\d{3})(\d{3})$/, '$1.$2.$3');
    }
  }
  